"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenderModel = function (_Observer) {
    _inherits(GenderModel, _Observer);

    function GenderModel(observers, id, request) {
        _classCallCheck(this, GenderModel);

        var _this = _possibleConstructorReturn(this, (GenderModel.__proto__ || Object.getPrototypeOf(GenderModel)).call(this, observers, id, request));

        _this.Gender = [];
        return _this;
    }
    /**
    * Liste von Mandanten
    * @type {Array} of Genders
    */


    _createClass(GenderModel, [{
        key: "GetGender",
        value: function GetGender() {
            var me = this;
            this.request.setRequest("/Gender");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        if (result.Data !== undefined && result.Data !== null) {
                            me.Gender = result.Data;

                            localStorage.setItem("Gender", result.Data);
                        }
                    }
                }
                var id = me.Id ? me.Id : "Gender";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return GenderModel;
}(_Observer3.default);

exports.default = GenderModel;